import client from './axiosClient';
export const getAllApprovals    = ()          => client.get('/approvals');
export const getPendingApprovals = ()         => client.get('/approvals/pending');
export const respondToApproval = (id, dto)   => client.post(`/approvals/${id}/respond`, dto);
export const approveRequest    = (id, dto)   => client.post(`/approvals/${id}/approve`, dto);
export const rejectRequest     = (id, dto)   => client.post(`/approvals/${id}/reject`, dto);
